export var Labels = {
    tabNames: {
        products: "Products",
        news: "News",
        events: "Events",
        downloads: "Downloads",
        pages: "Pages",
        sds: "SDS"
    },
    searchPlaceholder: "Type in your search term",
    searchButton: "Search",
    filterTitle: "Refine your search",
    noItemsFound: "No items matching your criteria were found.",
    showMore: "Show More",
    msdsDisclaimer: "",
    pastEvents: "Show past events",
    monthNames: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
    downloadIcs: "Add to your calendar",
    showPreviews: "Show document previews",
    more: "more",
    docFinder: "Safety Data Sheet",
    defaultSubtitle: "Product variant",
    availableMaterials: "Please choose one of the available packing options:",
    availableSdsFiles: "SDS files for",
    alternativeSdsFiles: "Please choose one of the available SDS files below. You can use the region selector to filter the list of available files.", //"As an alternative, you can download one of the other SDS files for this product:",
    noSDSFiles: "No Safety Data Sheets are available online for this product. Please contact our <a href='/company/contacts-and-locations/business-unit-contacts' target='_blank'>Service Desk</a>.",
    filterNotValid:"You need to provide 3 or more characters from the name of the product you are searching SDS files for.",
    anyCountry: "All countries",
    generating: "Generating file. Download will start shortly...",
    webinar: "Webinar",
    showGreenProducts: "Show Green Products",
    greenProductsTooltip: "According to ISO 16128 (Renewable Carbon Index above 50%)",
    bizzaboEventLocation: "Online Event",
    onlineEvent: "Online Event",
    showFacet: "Show filter",
    hideFacet: "Hide filter",
    pleaseWait: "Please wait until your current download completes",
    init() {
        var oThis = this;
        var labels = document.querySelectorAll("#search-labels > input[type='hidden']");
        if (labels && labels.length > 0) {
            labels.forEach(function (item) {
                var lid = item.id.split('-');
                if (item.value && lid && lid.length == 2) {
                    oThis[lid[1]] = item.value;
                }
                else if (item.value && lid && lid.length == 3) {
                    oThis.tabNames[lid[2]] = item.value;
                }
            });
        }
    }
}